import React from "react";
import { Player, BigPlayButton, ControlBar } from "video-react";
import "../../../node_modules/video-react/dist/video-react.css";
import { NftVideo, PlyBtn } from "../../constant/Index";
import { useSiteContentQuery } from "../../store/services/SitesettingService";

const Video = () => {
	const { data, isLoading } = useSiteContentQuery();
	let response = data?.response?.data[0];
	return (
		<>
			{/* <!-- Video Sec Start Here --> */}
			<section className="video_sec">
				<div className="container">
					<div className="play-btn">
						<figure>
							<img src={PlyBtn} alt="" className="img-fluid" />
						</figure>
					</div>
					<div className="video-container">
						<Player
							autoPlay
							loop={true}
							muted={true}
							controls={false}
							height={450}
							fluid={false}
							src={response?.video_path}
						>
							<ControlBar
								autoHide={true}
								disableDefaultControls={true}
							></ControlBar>
						</Player>
						{/* <video loop="true" width="100%" autoplay="autoplay" muted="">
							<source src={NftVideo} type="video/mp4" />
						</video> */}
					</div>
				</div>
			</section>
			{/* <!-- Video Sec End Here --> */}
		</>
	);
};

export default Video;
